/*
 * @Descripttion:
 * @version:
 * @Author: Mark
 * @Date: 2020-05-27 18:00:41
 * @LastEditors: dandan.Wu
 * @LastEditTime: 2021-03-29 18:45:13
 */

import Vue from 'vue'
import Toast from '@/components/toast/index.ts'
import { Dialog, Radio, Checkbox, Button, Cascader, Tag } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import Vconsole from 'vconsole'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import '@/assets/less/reset.less'
import '@/assets/less/common.less'
import '@/utils/rem'

const debug = process.env.NODE_ENV !== 'production'
debug && new Vconsole()
// new Vconsole()

import Confirm from '@/components/m-confirm/confirm.ts'
Vue.use(Confirm)

Vue.use(Dialog)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Cascader)
Vue.use(Tag)
Vue.use(Toast)

Vue.prototype.bus = new Vue()

Vue.config.productionTip = false
MgtvApi.callhandler('setWebview', {
  navigationBarTextStyle: 'white',
  popGesture: false,
})

// try {
//   if (Math.random() < 0.1) {
//     Sentry.init({
//       dsn: 'https://3c34c746ee9946e4affcc02e2b4042a3@sentry.log.mgtv.com/10',
//       integrations: [
//         new Integrations.Vue({
//           Vue,
//           attachProps: true,
//         }),
//       ],
//     })
//   }
// } catch (e) {
//   console.log(e)
// }

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
